import { DiffSquareProps } from './chatApplyProps';

/**
 * Generates visual squares representing the distribution of added/removed changes
 * Returns 1-3 squares based on the ratio of changes (red squares always come first)
 */
export function generateDiffSquares(added: number, removed: number): DiffSquareProps[] {
    const total = added + removed;

    // If no changes, return empty array
    if (total === 0) {
        return [];
    }

    // If only one type of change, show one square
    if (added === 0) {
        return [{ id: '1', type: 'removed' }];
    }
    if (removed === 0) {
        return [{ id: '1', type: 'added' }];
    }

    // Calculate ratio and determine squares (max 3)
    const ratio = added / removed;
    const squares: DiffSquareProps[] = [];

    if (ratio >= 2) {
        // At least 2:1 ratio - show 1 red, 2 green
        squares.push({ id: '1', type: 'removed' });
        squares.push({ id: '2', type: 'added' });
        squares.push({ id: '3', type: 'added' });
    } else if (ratio >= 1.5) {
        // 1.5:1 to 2:1 ratio - show 1 red, 2 green
        squares.push({ id: '1', type: 'removed' });
        squares.push({ id: '2', type: 'added' });
        squares.push({ id: '3', type: 'added' });
    } else if (ratio > 1) {
        // Slightly more added - show 1 red, 1 green
        squares.push({ id: '1', type: 'removed' });
        squares.push({ id: '2', type: 'added' });
    } else if (ratio === 1) {
        // Equal - show 1 red, 1 green
        squares.push({ id: '1', type: 'removed' });
        squares.push({ id: '2', type: 'added' });
    } else if (ratio >= 0.5) {
        // Slightly more removed - show 1 red, 1 green
        squares.push({ id: '1', type: 'removed' });
        squares.push({ id: '2', type: 'added' });
    } else {
        // At least 1:2 ratio (more removed) - show 2 red, 1 green
        squares.push({ id: '1', type: 'removed' });
        squares.push({ id: '2', type: 'removed' });
        squares.push({ id: '3', type: 'added' });
    }

    return squares;
}
